<template>
  <div class="col-center" style="width: 303px">
    <div style="width: 246px" class="col-center">
      <nuxt-link :to="link"><img :src="image" :class="imageClass" style="width: 183px;"/></nuxt-link>
      <TitleSm style=" margin-top: 30px; margin-bottom: 0px;">{{ title }}</TitleSm>
      <slot></slot>
      <Price>{{ price }}</Price>
      <a class="button" @click="addToCart(gid)">ADD TO CART</a>
      <div style="height: 10px"></div>
      <NuxtLink class="button" :to="link" style="margin-top: 0"
      >MORE INFO
      </NuxtLink>
    </div>
  </div>
</template>
<script setup lang="ts">
import {useCartStore} from "~/store/cart";

defineProps<{
  title: string
  link: string
  price: string
  image: string,
  imageClass: string,
  gid: string,
}>()

const cart = useCartStore();

async function addToCart(id?: string) {
  if (!id) {
    return;
  }
  await cart.addItem(id);
  navigateTo("/cart");
}

</script>
